import * as types from 'src/localization/types';

export const localized = (env: types.Env) => ({
  input: env.localizer('components.InstitutionFilter.input')
});
